export class CookieManager {
  static getCookie(name: string): string | null {
    const cookieArr = document.cookie.split(';');

    for (let i = 0; i < cookieArr.length; i++) {
      const cookiePair = cookieArr[i].split('=');
      const cookieName = cookiePair[0].trim();

      if (cookieName === name) {
        return decodeURIComponent(cookiePair[1]);
      }
    }

    return null;
  }
}
